import React, { Component } from "react";
import { object } from "prop-types";
import { Spinner } from "../../components";

class SignUp extends Component {
  static propTypes = {
    auth: object.isRequired
  };

  componentDidMount() {
    this.props.auth.signup();
  }

  render() {
    return <Spinner message="Redirecting you to sign up" />;
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/views/sign_up/SignUp.jsx